import each from 'lodash/each'

import Page from '../../classes/Page'
import { app } from '../../utils/store'
import { getData, setParameters } from '../../utils/json'
import { resultRendering } from '../../utils/locate'

import Maps from '../../modules/Maps'

export default class ArchiveStore extends Page {
    constructor() {
        super({
            id: 'archive_store',
            element: '[data-app-page]',
            elements: {
                nav: '#navigation-bottom-bar .nav',
                title: '#results > .headings .title',
                map: '#map',
                search: '#store-search',
                teases: '.tease.tease-store',
                results: '#results',
                filters: '#results .filter-togglers',
                counters: '[data-counter="bontempi-store"]',
                counters_corner: '[data-counter="corner"]',
                geolocate: '#geolocate-toggler',
                close: '.map--container button[data-map-closer]',
                submit: '[data-main-cta]'
            },
            scroll: (new URL(window.location.href).searchParams.has('query') || (new URL(window.location.href).searchParams.has('lat') && new URL(window.location.href).searchParams.has('lon'))) ? app.content : window
        })

        this.url = new URL(window.location.href)

        this.coordinates = {
            lat: 41.902782,
            lng: 12.496366
        }

        this.map = null

        app.body.style.setProperty('--navigation-height', `${app.header.clientHeight}px`)
    }

    async create() {
        super.create()

        if (this.elements.nav) {
            // setTimeout(() => {
            //     this.elements.nav.classList.remove('disable');
            //     this.elements.nav.focus();
            // }, 2000)

            this.elements.search.addEventListener('focus', (event) => { this.elements.nav.classList.add('focused') })
            this.elements.search.addEventListener('blur', (event) => { this.elements.nav.classList.remove('focused') })
        }

        // Main Archive Page
        if (!(this.url.searchParams.has('query') && this.url.searchParams.get('query') != "null") && (!this.url.searchParams.has('lat') && !this.url.searchParams.has('lon'))) {
            await this.onReload({ manipulate: true })

            this.map = new Maps({
                element: this.elements.map,
                zoom: {
                    value: 6,
                    controls: {
                        enable: false,
                    }
                },
                coordinates: {
                    lat: this.coordinates.lat,
                    lng: this.coordinates.lng
                },
                ui: false,
                wheel: false,
                fullscreen: false,
                streetView: false,
                mapTypeControl: false,
                draggable: true,
                stores: this.datas.stores
            })

            this.map.create({
                search: {
                    input: this.elements.search,
                    autoComplete: true,
                    geolocate: this.elements.geolocate
                },
                markers: true,
            })
        } else {
            // Filtered Archive Page
            await this.onReload({ manipulate: true })

            this.map = new Maps({
                element: this.elements.map,
                zoom: {
                    value: 10,
                    controls: {
                        enable: false,
                    }
                },
                coordinates: {
                    lat: this.coordinates.lat,
                    lng: this.coordinates.lng
                },
                ui: true,
                wheel: false,
                fullscreen: false,
                streetView: false,
                mapTypeControl: false,
                draggable: true,
                stores: this.datas.stores
            })

            this.map.create({
                search: {
                    input: this.elements.search,
                    autoComplete: true,
                    geolocate: this.elements.geolocate
                },
                markers: true
            }, true)
        }

        //
        // Actions
        if (this.elements.submit) {
            this.onSubmit(this.elements.submit)
        }

        /* Filters */
        if (this.elements.filters) {
            this.filters = {
                active: null,
                togglers: this.elements.filters.children,
                counter: document.querySelector('[data-counter="bontempi-store"] span.counter')
            }

            each(this.filters.togglers, (item) => {
                let toggler = item.querySelector('button')

                toggler.onclick = (event) => filter(event, {
                    map: this.map,
                    filters: this.filters,
                    available: document.querySelectorAll('.tease.available')
                })
            })

            // Filtered URL
            if (this.url.searchParams.has('filter')) {
                this.filters.active = this.url.searchParams.get('filter')

                window.addEventListener('DOMContentLoaded', () => {
                    each(this.filters.togglers, (item) => {
                        let toggler = item.querySelector('button')
                        console.log(this.url.searchParams.get('filter'), { toggler }, this.filters, this.filters.active == toggler.id)
                        if (this.filters.active == toggler.id) {
                            filter(null, {
                                map: this.map,
                                filters: this.filters,
                                available: document.querySelectorAll('.tease.available')
                            })
                            toggler.classList.add('active')
                        }
                    })
                })
            }

            function filter(event, { map = null, filters = {}, available = [] }) {
                each(filters.togglers, (filter) => { filter.children[0].classList.remove('active') })

                if (event) {
                    if (filters.active == event.target.id) {
                        event.target.classList.add('remove')
                        filters.active = null
                    } else {
                        event.target.classList.add('active')
                        filters.active = event.target.id
                    }
                }

                if (filters.active && filters.active == 'spaces') {
                    map.createMarkers(filters.active)
                    each(available, (entry) => {
                        if (entry.classList.contains(`tease-store--${filters.active}`)) {
                            entry.style.setProperty('display', 'block')
                            entry.classList.add('visible')
                        } else {
                            entry.style.setProperty('display', 'none')
                            entry.classList.remove('visible')
                        }
                    })
                } else {
                    map.createMarkers(null)
                    each(available, (entry) => {
                        entry.style.setProperty('display', 'block')
                        entry.classList.add('visible')
                    })
                }

                filters.counter.innerHTML = document.querySelectorAll('.tease-store.visible').length
            }
        }
    }

    onSubmit = (entry) => {
        entry.onclick = (event) => {
            event.preventDefault()
            let data = getData(this.elements.search)
            setParameters(this.url, data)
            location.reload()
        }
        this.elements.search.onkeyup = (event) => {
            if (event.key === 'Enter') {
                event.preventDefault()
                let data = getData(this.elements.search)
                setParameters(this.url, data)
                location.reload()
            }
        }
    }

    onReload = async () => {
        if (!(this.url.searchParams.has('query') && this.url.searchParams.get('query') != "null") && (!this.url.searchParams.has('lat') && !this.url.searchParams.has('lon'))) {
            this.datas = await resultRendering(this.coordinates, 500, {
                querySelector: this.elements.teases,
                counterLabel: this.elements.counters,
                results: document.querySelector('section.result')
            })
        } else {
            this.location = this.url.searchParams.get('query')
            this.elements.title.innerHTML = this.location

            this.coordinates = {
                lat: Number(this.url.searchParams.get('lat')),
                lng: Number(this.url.searchParams.get('lon'))
            }

            this.datas = await resultRendering(this.coordinates, 50, {
                querySelector: this.elements.teases,
                counterLabel: this.elements.counters,
                results: document.querySelector('section.result')
            })
        }

    }

    addEventListeners() {
        window.addEventListener('resize', () => {
            // app.content.style.setProperty('--header-height', `${this.elements.header.clientHeight}px`)
        })
    }

    destroy() {
        super.destroy()
    }
}